import React, { Component } from 'react';
import _ from 'lodash';
import { Map } from 'react-leaflet';
import { connect } from 'react-redux';
import { Helmet } from 'react-helmet';
import {
	getCountryParameter,
	getSongIdParameter
} from '../../state-management/actions/parameter-actions';
import {
	getAllSongsRequest,
	getCountriesWithSongsRequest,
	getGenresRequest,
	getUserFavoriteSongsRequest,
	getUserUploadedSongsRequest
} from '../../state-management/actions/songs-actions';
import { worldDataPromise } from './CountriesData';
import '../../style/App.css';
import { capitalizeWords } from '../../helpers/helpers';
import CountrySongsList from './CountrySongsList';
import WorldGeoJSON from './WorldGeoJSON';
import CountriesList from './CountriesList';

import '../../style/Map.css';
import FloatingViewOptions from './FloatingViewOptions';
import View from '../layout/View';
import ModalFirstTimeVisit from './ModalFirstTimeVisit';
import Cookies from 'universal-cookie';
import YoutubeSinglePlay from '../YoutubeComponents/YoutubeSinglePlay';
import SelectedCountryDetails from './SelectedCountryDetails';

class MusicalMap extends Component {
	constructor(props) {
		super(props);

		this.state = {
			location: {
				lat: 51.505,
				lng: -0.09
			},
			zoom: 2,
			worldData: null,
			namesAndRegions: null,
			userUploadedSongs: null,
			cookieIsAboutViewed: false
		};
	}

	componentDidMount() {
		const {
			// allCountriesSongs, 
			authenticated,
			countriesGenres,
			getAllSongsRequest,
			getCountriesWithSongsRequest,
			getGenresRequest,
			getUserFavoriteSongsRequest,
			getUserUploadedSongsRequest
		} = this.props;

		getAllSongsRequest();
		getCountriesWithSongsRequest();
		// if (countriesGenres.length === 0) {
		// 	getGenresRequest();
		// }

		if (authenticated) {
			// console.log('loadieee');
			getUserFavoriteSongsRequest();
			getUserUploadedSongsRequest();
		}

		worldDataPromise.then((response) => {

			const geojson = _(response)
				.map(response => {
					const {additionalData:{name}} = response;

					return {
						countryName:name,
						youtubeId:''
						}
					
				})
				.value();

			const geojson2 = geojson.reduce((obj, item) => Object.assign(obj, { [item.countryName]: item }),{})
			// console.log('geo json', geojson);
			// console.log('geojson2', JSON.stringify(geojson2));
			this.setState({
				worldData:
				{
					type: 'FeatureCollection',
					features: response
				}
			}
			);
		});

		this.checkParameters();

		const cookies = new Cookies();

		const isAboutViewed = cookies.get('isAboutViewed');


		if (!isAboutViewed) {
			console.log('not preset');
			cookies.set('isAboutViewed', 'true');


		}
		else {
			this.setState((prevState) => ({
				...prevState,
				cookieIsAboutViewed: true
			}));

		}

	}

	checkParameters = () => {
		const { getCountryParameter, getSongIdParameter, match } = this.props;
		const { params } = match;

		if (!_.isEmpty(params)) {
			const { parameterCountry, parameterSongId } = params;

			getCountryParameter(capitalizeWords(parameterCountry));
				if (parameterSongId) {
					getSongIdParameter(parameterSongId);
				}

		}
	}

	// manageParameters = () => {
	// 	const { parameterCountry, parameterSongId } = params;
	// 	getCountryParameter(capitalizeWords(parameterCountry));
	// 	if (parameterSongId) {
	// 		getSongIdParameter(parameterSongId);
	// 	}
	// }

	closeModalFirstTimeVisit = () => {
		this.setState((prevState) => ({
			...prevState,
			cookieIsAboutViewed: true
		}));

	}

	setHelmetContent = (selectedCountryName, countryParameter) => {
		if (selectedCountryName) {
			return `Anthem of ${selectedCountryName}`
		}
		else if (countryParameter) {
			return `Anthem of ${countryParameter}`
		}
		else {
			return 'Library of Anthems of the World.'
		}
	}

	render() {
		const position = [this.state.location.lat, this.state.location.lng];
		const {
			cookieIsAboutViewed,
			worldData,
			zoom
		} = this.state;

		const {
			countryParameter,
			selectedCountryName,
			// showCountriesListModal,
			showCountrySongsModal,
			showSongInfoModal,
			viewOptionSelected,

			selectedCountryProperties,
			isCountrySelected
		} = this.props;

		const {
			youtubeId
		} = selectedCountryProperties;
		// console.log('countryParameter', countryParameter);
		// console.log('selectedCountryName', selectedCountryName);

		const helmetContent = this.setHelmetContent(selectedCountryName, countryParameter);

		return (
			<View>
				<Helmet>
					<title>{helmetContent}</title>
					<meta name="description" content={helmetContent} />
				</Helmet>
				{/* <NavigationBar /> */}				
				<div className="super-container">
					{
						(viewOptionSelected === 'Both' || viewOptionSelected === 'ListOnly') &&
						<CountriesList />
					}
					{
						(viewOptionSelected === 'Both' || viewOptionSelected === 'MapOnly') &&
						<div className="map-container">
							<Map
								className="map"
								worldCopyJump={true}
								center={position}
								zoom={zoom}
								minZoom={2}
								maxZoom={6}
							>
								{worldData && <WorldGeoJSON worldData={worldData} />}
							</Map>

							<FloatingViewOptions />
							
						</div>
					}
					{showCountrySongsModal && <CountrySongsList />}
					{!cookieIsAboutViewed &&
						<ModalFirstTimeVisit
							closeModalFirstTimeVisit={this.closeModalFirstTimeVisit}
						/>}	
							{isCountrySelected && 
					<YoutubeSinglePlay
					musicVideo={youtubeId}
					/>}	
						
				</div>
				{
								isCountrySelected &&
								<SelectedCountryDetails/>
							}		
			</View>
		);
	}
}

const mapDispatchToProps = (dispatch) => {
	return {
		getAllSongsRequest: () => dispatch(getAllSongsRequest()),
		getCountryParameter: (countryParameter) => dispatch(getCountryParameter(countryParameter)),
		getCountriesWithSongsRequest: () => dispatch(getCountriesWithSongsRequest()),
		getGenresRequest: () => dispatch(getGenresRequest()),
		getSongIdParameter: (songIdParameter) => dispatch(getSongIdParameter(songIdParameter)),
		getUserFavoriteSongsRequest: () => dispatch(getUserFavoriteSongsRequest()),
		getUserUploadedSongsRequest: () => dispatch(getUserUploadedSongsRequest())
	};
};
const mapStateToProps = state => {
	const { mapReducers, modalReducers, parameterReducers, songsReducers } = state;
	const {
		countryNameTooltip
	} = mapReducers;
	const {
		countryParameter
	} = parameterReducers;
	const {
		showAddNewSongModal,
		showAddSongToPlaylistModal,
		showCountriesListModal,
		showCountrySongsModal,
		showCreatePlaylistModal,
		showRandomSongsModal,
		showSearchSongModal,
		showSongInfoModal,
		showUserPlaylistsModal,
		viewOptionSelected
	} = modalReducers;
	const {
		isCountrySelected,
		selectedCountryName,
		selectedCountryProperties
	} = songsReducers
	return {
		countriesGenres: songsReducers.countriesGenres,
		countryNameTooltip,
		countryParameter,		
		selectedCountryProperties,
		showAddNewSongModal,
		showAddSongToPlaylistModal,
		showCountriesListModal,
		showCountrySongsModal,
		showCreatePlaylistModal,
		showEditSongModal: modalReducers.showEditSongModal,
		showLoginModal: modalReducers.showLoginModal,
		showRandomSongsModal,
		showRegistrationModal: modalReducers.showRegistrationModal,
		showSearchSongModal,
		showSongInfoModal,
		showUserDashboardModal: modalReducers.showUserDashboardModal,
		showUserPlaylistsModal,
		viewOptionSelected,


		selectedCountryName,
		selectedCountryProperties,
		isCountrySelected
	};
};

export default connect(mapStateToProps, mapDispatchToProps)(MusicalMap);
